import { CommercialOperationDate } from '@price-card/models/commercial-operation-date.model';
import { CommercialOperationDateGateway } from '@price-card/gateways/commercial-operation-date.gateway';
import { formatGetHeaders } from '@configurations/api-configuration';
import { environment } from '../../../../../environments/environment';

export class ApiCommercialOperationDateGateway implements CommercialOperationDateGateway {
  private readonly commercialOperationDateApi = `${environment.backend_url}/api/v1/price-card/cod`;

  async retrieveAll(): Promise<CommercialOperationDate[]> {
    try {
      const response = await fetch(`${this.commercialOperationDateApi}`, await formatGetHeaders());
      const data = await response.json();
      return data.sort((a: CommercialOperationDate, b: CommercialOperationDate) => b.year - a.year);
    } catch (error) {
      throw new Error('Error retrieving commercial operation dates: ' + error);
    }
  }
}
